"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE = exports.isIOS = exports.isAndroid = exports.isMobile = exports.isNode = exports.isWebWorker = exports.isBrowser = exports.checkMobileRegExp = void 0;
const checkMobileRegExp = (text) => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(text);
exports.checkMobileRegExp = checkMobileRegExp;
exports.isBrowser = typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    !!navigator.userAgent;
exports.isWebWorker = typeof self === 'object' &&
    self.constructor &&
    self.constructor.name === 'DedicatedWorkerGlobalScope';
exports.isNode = typeof process !== 'undefined' &&
    process.versions != null &&
    process.versions.node != null;
exports.isMobile = exports.isBrowser && (0, exports.checkMobileRegExp)(navigator.userAgent);
exports.isAndroid = exports.isBrowser && /Android/i.test(navigator.userAgent);
exports.isIOS = exports.isBrowser && /iPhone|iPad|iPod/i.test(navigator.userAgent);
exports.isIE = exports.isBrowser &&
    typeof navigator !== 'undefined' &&
    (navigator.userAgent.includes('.NET CLR') ||
        navigator.appVersion.includes('MSIE'));
//# sourceMappingURL=index.js.map